function initPageFeatures() {
  // 初始化 Swiper
  const swiperContainer = document.querySelector('.exceptional-coffee .swiper');
  if (
    swiperContainer &&
    !swiperContainer.classList.contains('swiper-initialized')
  ) {
    new Swiper(swiperContainer, {
      loop: true,
      autoplay: false,
      spaceBetween: 30,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });
  }

  // 初始化动画
  // if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  //   gsap.registerPlugin(ScrollTrigger);
  //  const sections = gsap.utils.toArray('main section');

  // sections.forEach((el, index) => {
  //   if (index < 3) {
  //     // 前三个元素：直接动画播放，不使用 ScrollTrigger
  //     gsap.from(el, {
  //       opacity: 0,
  //       y: 100,
  //       duration: 1,
  //       ease: 'power2.out',
  //     });
  //   } else {
  //     // 其他元素：使用 ScrollTrigger
  //     gsap.from(el, {
  //       opacity: 0,
  //       y: 100,
  //       duration: 1,
  //       ease: 'power2.out',
  //       scrollTrigger: {
  //         trigger: el,
  //         start: 'top 80%',
  //         toggleActions: 'play none none reverse',
  //         once: false,
  //       },
  //     });
  //   }
  // });

  // }
}

window.addEventListener('load', initPageFeatures);

// 页面内容更新时再次运行（适配动态加载场景）
document.addEventListener('shopify:section:load', initPageFeatures);
document.addEventListener('shopify:section:reorder', initPageFeatures);
document.addEventListener('shopify:section:select', initPageFeatures);
